/**
 * @generated SignedSource<<0725731d8833953f76bdc65b98762aa9>>
 * @relayHash 48b48eeb697ca08369627e6b23179df6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 596c58a342d05103e1420f77524c2cf42900488ee4aa4d523943ea63d4119db8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "596c58a342d05103e1420f77524c2cf42900488ee4aa4d523943ea63d4119db8",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
